import PropTypes from 'prop-types';
import { useState } from 'react';
import Link from 'next/link';

import CorusImage from '../CorusImage/CorusImage';

const ChefsHostsDetails = ({ details }) => {
	const [hover, setHover] = useState(false);

	const {
		authorId,
		profileAltTxt,
		profileLink,
		profilePic,
		profileTitle,
		tags,
	} = details;

	return (
		<div className="chefs-hosts__grid__item" key={authorId}>
			<Link
				href={profileLink}
				aria-label={`Link to ${profileTitle} profile`}
				className="profile-img-link"
			>

				<CorusImage
					alt={profileAltTxt}
					className="profile-img"
					height={565}
					src={profilePic}
					title={profileTitle}
					width={848}
				/>

			</Link>
			<div className={`details hover-style--${Boolean(hover)}`}>
				<Link href={profileLink}>

					<p
						className="name"
						onBlur={() => setHover(false)}
						onFocus={() => setHover(true)}
						onMouseOver={() => setHover(true)}
						onMouseOut={() => setHover(false)}
					>
						{profileTitle}
					</p>

				</Link>
				<ul className="show-tags">
					{tags}
				</ul>
			</div>
		</div>
	);
};

ChefsHostsDetails.propTypes = {
	details: PropTypes.shape({
		authorId: PropTypes.number.isRequired,
		profileAltTxt: PropTypes.string.isRequired,
		profileLink: PropTypes.string.isRequired,
		profilePic: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object,
		]).isRequired,
		profileTitle: PropTypes.string.isRequired,
		tags: PropTypes.oneOfType([
			PropTypes.array,
			PropTypes.bool,
		]),
	}).isRequired,
};

export default ChefsHostsDetails;
